<template>
    <div>
        <h4>Questions</h4>

        <v-row no-gutters>
            <v-icon small>mdi-information-outline</v-icon>
            <span class="caption">
                Select a question below to maintain that question
            </span>
        </v-row>

        <v-row class="mt-1">
            <v-col cols="3" v-for="(question, idx) in ctrl.formData.questionnaireQuestions" :key="idx">
                <v-card hover @click="ctrl.goToQuestion(question)">
                    <v-row no-gutters justify="center" align="center">
                        <span class="subtitle-2">
                            <b>{{ question.questionContent[0].question }}</b>
                        </span>
                    </v-row>
                    <v-divider></v-divider>
                    <v-col cols="12">
                        <img src="@/assets/icons/question_variant.png" alt="" width="100%" />
                    </v-col>
                    <v-divider></v-divider>
                    <v-row no-gutters justify="center">
                        <v-col cols="12" class="text-center">
                            <v-btn block x-small color="error" @click.stop="question_ctrl.promptDelete(question)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        props: {
            ctrl: Object,
            question_ctrl: Object
        }
    }
</script>